import { render, staticRenderFns } from "./InviteMentor.vue?vue&type=template&id=763f2b12&"
import script from "./InviteMentor.vue?vue&type=script&lang=js&"
export * from "./InviteMentor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports